import styled from 'styled-components'
import { collapsedSidePanelWidth, expandedSidePanelWidth } from '~/constants'

export const SidePanelSection = styled.section<{ isCollapsed: boolean }>`
  position: relative;
  padding-left: 10px;
  height: 100%;
  width: ${({ isCollapsed }) => (isCollapsed ? collapsedSidePanelWidth : expandedSidePanelWidth)};

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  border-left: 2px solid ${props => props.theme.colors.colore9ecf3};
  transition: width 0.3s ease-in-out;
  z-index: 10;

  .buttonPosition {
    position: relative;
    margin-left: ${({ isCollapsed }) => (isCollapsed ? '0px' : '6px')};
    align-self: start;
    transition-delay: ${({ isCollapsed }) => (isCollapsed ? '0.2s' : '0s')};
  }
`

export const SidePanelContent = styled.div<{ isCollapsed: boolean }>`
  position: relative;
  width: 100%;
  transition-delay: ${({ isCollapsed }) => (isCollapsed ? '0s' : '3s')};
  opacity: ${({ isCollapsed }) => (isCollapsed ? '0' : '1')};
  font-size: ${({ isCollapsed }) => (isCollapsed ? '0' : 'auto')};
  transition: opacity 0.5s ease-in-out;
  white-space: nowrap;
  height: 90%;
`

export const ContainerTags = styled.div`
  position: relative;
  margin-bottom: 10px;

  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
`
